// @ts-nocheck
import styled from 'styled-components';
import type { StatelessFunctionalComponent } from 'react';
import { getTheme } from 'settings/theme/index';
import { TABLET_WIDTH, TABLET_SMALL_WIDTH } from 'commons/constants';

const {
  palette: { neutral },
  noodera: { fontTypes, spacing },
} = getTheme();
export const Wrapper: StatelessFunctionalComponent<any> = styled.div`
  padding: ${spacing.x5};

  @media only screen and (min-width: ${TABLET_SMALL_WIDTH}px) {
    padding: ${spacing.x5} 0;
  }

  @media only screen and (min-width: ${TABLET_WIDTH}px) {
    margin-top: ${spacing.x2};
  }
`;
export const ProgramsTitle: StatelessFunctionalComponent<any> = styled.h3`
  ${fontTypes.font3Medium};
  color: ${neutral.hundred};
  margin-bottom: ${spacing.x3};
`;
export const CardContainer: StatelessFunctionalComponent<any> = styled.div`
  flex-wrap: wrap;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(30rem, 1fr));
  grid-gap: ${spacing.x6};
  margin-bottom: ${spacing.x3};

  & > div {
    flex: 1;
  }

  @media screen and (max-width: ${TABLET_WIDTH}px) {
    & > div {
      min-width: 100%;
      margin-right: 0;
      margin-bottom: ${spacing.x6};
    }
  }
`;
export const ProgramsSubTitle: StatelessFunctionalComponent<any> = styled.h3`
  ${fontTypes.font4Medium};
  color: ${neutral.eighty};
  margin-bottom: ${spacing.x5};
`;
